<sirius-card-collection-text [title]="resolvedTitle()" [text]="resolvedTextHtml()" />
@if (resolvedItems(); as items) {
    <sirius-slider (scrollNextEvent)="onScrollNext()" (scrollPreviousEvent)="onScrollPrevious()">
        @for (item of items; track item.link?.href ?? $index) {
            <div class="sir-card-container">
                <ng-template
                    siriusCardElement
                    [cardCount]="items.length"
                    (selectEvent)="onSelect($index)"
                    [config]="item"
                    [imageData]="imageData()"
                    [cardSize]="cardSize()"
                    [containerType]="'slider'"
                >
                </ng-template>
            </div>
        }
    </sirius-slider>
}
